@if (vm$ | async; as vm) {
  <div class="change-password-form-container">
    <h2 class="font-weight-bold align-left">{{'auth.change_password' | translate}}</h2>
    <hr style="border: 0.5px solid #d1d1d1;">
    @if (vm.passwordChanged) {
      <div class="uw-success-message">
        {{ "common.change_success_message" | translate }}
      </div>
    }
    @if (vm.errorMessage) {
      <div class="uw-error-message error-container">
        {{ vm.errorMessage | translate }}
      </div>
    }
    <app-change-password-form
      (changePassword)="save($event)"
      [buttonLoading]="buttonLoading"
    ></app-change-password-form>
  </div>
  <!-- <div class="uw-field">
  <label for="currentPassword" class="uw-label">{{ "auth.current_password" | translate }}</label>
  <input #currentPassword id="currentPassword" class="uw-input" type="password" formControlName="currentPassword">
  <div class="d-flex">
    <div>
      <input type="checkbox" (click)="showPassword(currentPassword)">
    </div>
    <div class="ml-2"> {{'common.show_password' | translate}} </div>
  </div>
      <span class="uw-error-message" *ngIf="(form.get('currentPassword')?.dirty || form.get('currentPassword')?.touched)
             && form.get('currentPassword')?.errors?.required">
  {{ "common.please_enter_the_current_password" | translate }}</span>
</div>     -->
<!-- <div class="uw-field">
<label for="newPassword" class="uw-label">{{ "auth.new_password" | translate }}</label>
<input #newPassword id="newPassword" class="uw-input" type="password" formControlName="newPassword" maxlength="16">
<div class="d-flex">
  <div>
    <input type="checkbox" (click)="showPassword(newPassword)">
  </div>
  <div class="ml-2"> {{'common.show_password' | translate}} </div>
</div>
      <span class="uw-error-message" *ngIf="(form.get('newPassword')?.dirty || form.get('newPassword')?.touched)
      && form.get('newPassword')?.errors?.required">
{{ "common.password_is" | translate }}</span>
<span class="uw-error-message" *ngIf="form.get('newPassword')?.dirty && form.get('newPassword')?.errors?.pattern">{{
"auth.pwd_requirements_msg" | translate }}</span>
</div>
<div class="uw-field">
  <label for="confirmPassword" class="uw-label">{{ "auth.confirm_password" | translate }}</label>
  <input #confirmPassword id="confirmPassword" class="uw-input" type="password" formControlName="confirmPassword" maxlength="16">
  <div class="d-flex">
    <div>
      <input type="checkbox" (click)="showPassword(confirmPassword)">
    </div>
    <div class="ml-2"> {{'common.show_password' | translate}} </div>
  </div>
      <span class="uw-error-message" *ngIf="(form.get('confirmPassword')?.dirty || form.get('confirmPassword')?.touched)
      && form.get('confirmPassword')?.errors?.required">
    {{"common.confirm_pwd_reqd" | translate }}
  </span>
  <span class="uw-error-message"
        *ngIf="(
          !form.get('confirmPassword')?.errors?.required
         && form.get('confirmPassword')?.value !== form.get('newPassword')?.value)
        &&  (form.get('confirmPassword')?.dirty || form.get('confirmPassword')?.touched)">
    {{ "common.confirm_password_mismatch_with_new_password" | translate }}
  </span>
</div> -->
<!-- <div class="uw-actions">
<button class="uw-default-button" (click)="save(form.value)"
     [disabled]="!form.valid || form.get('confirmPassword')?.value !== form.get('newPassword')?.value
     || form.pristine">
{{ "common.save" | translate }}</button>
</div> -->
}